// test1584
(1584 && 0);
